export class ElementorTeaserText {

    private static teaserHeight: number;
    private static moreText: HTMLElement;
    private static moreTextInner: HTMLElement;
    private static moreBar: HTMLElement;

    public static openTextOnClick(openID){
        let barOpenClass = 'text-open';
        ElementorTeaserText.moreBar = document.getElementById('more-block-' + openID);
        ElementorTeaserText.moreText = document.getElementById('block-' + openID);
        ElementorTeaserText.moreTextInner = document.getElementById('inner-block-' + openID );

        if( ElementorTeaserText.moreBar.classList.contains(barOpenClass) ) {
            ElementorTeaserText.moreText.classList.remove('open');
            ElementorTeaserText.teaserHeight = 0;
            ElementorTeaserText.moreText.style.height = ElementorTeaserText.teaserHeight.toString() + 'px';
            ElementorTeaserText.moreBar.classList.remove(barOpenClass);
        } else {
            ElementorTeaserText.teaserHeight = ElementorTeaserText.moreTextInner.offsetHeight;
            ElementorTeaserText.moreText.style.height = ElementorTeaserText.teaserHeight.toString() + 'px';
            ElementorTeaserText.moreBar.classList.add(barOpenClass);
            setTimeout(function (){
                ElementorTeaserText.moreText.classList.add('open');
            }, 1000);
        }
    }
}
